<nb-card class="masonry-item">
  <nb-card-header>
    {{ hub.Name }}
    <br />
    <small class="text-muted">{{ hub.HubType }}</small>
  </nb-card-header>
  <lockvue-hub-short-info [hub]="hub"></lockvue-hub-short-info>
  <lockvue-hub-view-locks-button class="m-2" [value]="hub"></lockvue-hub-view-locks-button>
</nb-card>
